import React, { useEffect, useRef } from 'react'
import { MessagesTypes } from 'features/common/notes-tab'
import { Box, Button, FormControl, FormLabel, HStack, Textarea } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { useAccountDetails } from 'api/vendor-details'
import { useProjectNotes } from 'api/projects'

type receivableNotesProps = {
  setMessage?: any
  projectId: number | string | undefined | null
  message
  sendNote
}

export const ReceivableNotes = React.forwardRef((props: receivableNotesProps) => {
  const { setMessage, projectId, message, sendNote } = props
  const { t } = useTranslation()
  const messagesEndRef = useRef<null | HTMLDivElement>(null)
  const { data: account } = useAccountDetails()
  const { notes = [] } = useProjectNotes({
    projectId: projectId,
  })

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    scrollToBottom()
  }, [notes])

  return (
    <>
      <Box p={'10px'} h="100%">
        <Box minH="450px">
          {notes && (
            <Box maxH="280px" overflowY={'auto'}>
              {notes.map(note => {
                return note === account?.login ? <MessagesTypes userNote={note} /> : <MessagesTypes otherNote={note} />
              })}
              <div ref={messagesEndRef} />
            </Box>
          )}
          <FormControl>
            <FormLabel fontSize="16px" color="gray.600" fontWeight={500}>
              {t(`enterNewNote`)}
            </FormLabel>
            <Textarea
              datatest-id="notes-textarea"
              flexWrap="wrap"
              h={'120px'}
              value={message}
              onChange={e => {
                setMessage(e.target.value)
              }}
            />
          </FormControl>
        </Box>

        <Box borderTop="2px solid #e2e8f0" mt="20px">
          <HStack mt="20px" mr="20px" spacing="16px" w="100%" justifyContent="end">
            <Button colorScheme="darkPrimary" type="submit" onClick={(e: any) => sendNote()} isDisabled={!message}>
              {t('save')}
            </Button>
          </HStack>
        </Box>
      </Box>
    </>
  )
})
export default ReceivableNotes
